import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d024e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "absolute block shadow-xl z-10",
  style: {"top":"1.6rem","right":"-0.5rem","border-radius":"1rem"}
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative block cursor-pointer",
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nested.hide.value = true)),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nested.hide.value = false))
  }, [
    _renderSlot(_ctx.$slots, "title", {}, undefined, true),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (value, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "rounded"
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["drop-card-item border-r border-l", {
              'list-round-first border-t': index == 0,
              'list-round-last border-b': index == _ctx.itemList.length - 1
            }]),
                onClick: ($event: any) => (_ctx.click(index))
              }, _toDisplayString(value), 11, _hoisted_2)
            ]))
          }), 128))
        ], 512), [
          [_vShow, !_ctx.nested.hide.value]
        ])
      ]),
      _: 1
    })
  ], 32))
}